import React from 'react';
import { Text, XStack } from 'tamagui';

interface MenuItemProps {
  rightElement?: React.ReactNode;
  label: string;
  onPress?: () => void;
}

export const MenuItem: React.FC<MenuItemProps> = ({ rightElement, label, onPress }) => (
  <XStack
    minHeight={90.6}
    borderRadius={16}
    padding="$5"
    alignItems="center"
    justifyContent="space-between"
    pressStyle={{ opacity: 0.8 }}
    backgroundColor="$transparentBorder"
    onPress={onPress}>
    <Text color="$white12" fontSize="$8.5" fontFamily="$body">
      {label}
    </Text>
    {rightElement}
  </XStack>
);
